<template>
  <div class="DZBL">
    <iframe class="znr" ref="prints" :src="src"></iframe>
  </div>
</template>

<script>
export default {
  name: "IFTC",
  data() {
    return {
      src: ''
    }
  },
  props: {
    ids: {
      default: ''
    }
  },
  created() {
    if (!this.$store.state.users.employees) return this.$alert('员工未登录，请登录！', '提示').then(res => this.$router.push({path: '/employeesLanding'}))
    let exid = this.$store.state.users.employees.ExpertId,
        csid = this.ids
    this.src = this._getUrl('ChooseReport_MR') + `CustomerId=${this.$store.state.users.CsUser.CustomerId}&ChooseId=${csid}&ExpertId=${exid}`
  }
}
</script>

<style scoped lang="scss">
.znr {
  width: 100%;
  height: 65vh;
}
</style>
